import { useEffect, useState } from "react";
import { User_Authentication } from '../../../../user_authentication/User_Authentication';
import { Get_Pandit_List } from '../../../../api/pooja/Pooja';
import { Link, useLocation, useNavigate } from "react-router-dom";
import Loader from '../../../../loader/Loader'
import Header from "../../../common/header/Header";
import Footer from "../../../common/footer/Footer";
import { IMG_BASE_URL, WEB_DOMAIN_KEY } from '../../../../config/Config'
import Common_Images_Transport from '../../../common/common_imges_transport/Common_Images_Transport'
import { get_Page_Seo } from "../../../../api/global/Global";
import { Helmet } from "react-helmet";
import parse from 'html-react-parser';

const Pandit_Consultant = () => {

    const navigate = useNavigate();
    const [userLocation, setLocation] = useState(null);
    const [error, setError] = useState(null);
    const [pageSeo, set_Page_Seo] = useState({})

    const [is_loading, set_Is_Loading] = useState(false);
    const [astro_list, set_Astro_List] = useState([]);
    const Get_user_is_active = localStorage.getItem("user_is_active")
    const location = useLocation()
    const { category_id, id, package_price, pooja_id, package_detail, package_name, title, image, description, short_description, selected_date, selected_time, muhurat_info } = location?.state


    const poojaLocation = JSON.parse(localStorage.getItem("poojaLocation") || "{}");
    const language = localStorage.getItem("selectedLanguage")


    const [currentPage, setCurrentPage] = useState(1);
    const productsPerPage = 12;

    const validAstroData = Array.isArray(astro_list) ? astro_list : [];
    const totalPages = Math.ceil(validAstroData.length / productsPerPage);

    // Slice data for current page
    const startIndex = (currentPage - 1) * productsPerPage;
    const currentAstroList = validAstroData.slice(startIndex, startIndex + productsPerPage);

    const getPaginationItems = () => {
        const items = [];
        if (totalPages <= 5) {
            for (let i = 1; i <= totalPages; i++) {
                items.push(i);
            }
        } else {
            if (currentPage <= 3) {
                items.push(1, 2, 3, 4, '...', totalPages);
            } else if (currentPage >= totalPages - 2) {
                items.push(1, '...', totalPages - 3, totalPages - 2, totalPages - 1, totalPages);
            } else {
                items.push(1, '...', currentPage - 1, currentPage, currentPage + 1, '...', totalPages);
            }
        }
        return items;
    };

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handleNext = () => {
        if (currentPage < totalPages) setCurrentPage(currentPage + 1);
    };

    const handlePrev = () => {
        if (currentPage > 1) setCurrentPage(currentPage - 1);
    };

    useEffect(() => {
        const getLocation = () => {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(
                    (position) => {
                        setLocation({
                            lat: position.coords.latitude,
                            lng: position.coords.longitude,
                        });
                    },
                    (err) => setError(err.message),
                    {
                        enableHighAccuracy: true,
                        timeout: 30000, // Increased timeout
                        maximumAge: 0 // No cache - force fresh location
                    }
                );
            } else {
                setError("Geolocation is not supported by this browser.");
            }
        };
        getLocation();
    }, []);
    //    useEffect(() => {
    //     const getLocation = () => {
    //         if (navigator.geolocation) {
    //             navigator.geolocation.getCurrentPosition(
    //                 (position) => {
    //                     setLocation({
    //                         lat: position.coords.latitude,
    //                         lng: position.coords.longitude,
    //                     });
    //                 },
    //                 (err) => setError(err.message),
    //                 {
    //                     enableHighAccuracy: true,
    //                     timeout: 10000,
    //                     maximumAge: 300000 // 5 minutes cache
    //                 }
    //             );
    //         } else {
    //             setError("Geolocation is not supported by this browser.");
    //         }
    //     };
    //     getLocation();
    // }, []);

    useEffect(() => {
        const Get_Page_Seo = async () => {
            set_Is_Loading(true);
            try {
                const response = await get_Page_Seo()
                if (response?.data?.status == 200) {
                    const seo = response?.data?.data?.seo
                    const filterSeoPage = seo?.find(page => page?.page_name === "Pandit Consultant")
                    set_Page_Seo(filterSeoPage)
                }
            } catch (error) {
                console.error(error)
            } finally {
                set_Is_Loading(false);
            }
        }

        Get_Page_Seo()
    }, [])

    useEffect(() => {
        const fetchPanditList = async () => {
            set_Is_Loading(true);
            try {

                // Handle Authenticated or Guest user logic
                // if (Get_user_is_active) {
                //     const token = User_Authentication();
                //     if (!token) {
                //         throw new Error("User token not found");
                //         // return;
                //     }



                // } 
                const data = {
                    category_id,
                    //   latitude: "24.772608",
                    // longitude: "73.7574912",
                    latitude: userLocation?.lat || "",
                    longitude: userLocation?.lng || "",
                    booking_date: selected_date || "",
                }
                const response = await Get_Pandit_List(data);
                if (response?.status == 200) {
                    set_Astro_List(response?.data?.pandit_list || []);
                }

            } catch (error) {
                console.error(" Error fetching Astro List:", error);
            } finally {
                set_Is_Loading(false);
            }
        };

        if (userLocation?.lat && userLocation?.lng) {
            fetchPanditList();
        }
    }, [id, category_id, Get_user_is_active, userLocation]);


    return (
        <>
            <Helmet>
                <title>{pageSeo?.meta_title}</title>
                <meta name="description" content={pageSeo?.meta_description} />
                <link rel="canonical" href={`${WEB_DOMAIN_KEY}pandit-consultant`} />
                <link rel="alternate" hreflang="en-us" href={`${WEB_DOMAIN_KEY}pandit-consultant`} />

            </Helmet>
            <Header />
            {
                is_loading ? (
                    <Loader />
                ) : (
                    <>
                        <section className='banner-section'>
                            <div className={`${pageSeo?.image ? "block" : "hidden"} relative`}>
                                <img src={`${IMG_BASE_URL}${pageSeo?.image}`} alt={pageSeo?.alt
                                } className='w-full h-[200px] md:h-[300px] lg:h-[400px] object-cover' />


                            </div>
                        </section>
                        <section className="gi-category py-[40px] max-[767px]:p-[15px]">
                            <div
                                className="flex flex-wrap justify-between items-center mx-auto min-[1400px]:max-w-[1320px] min-[1200px]:max-w-[1140px] min-[992px]:max-w-[960px] min-[768px]:max-w-[720px] min-[576px]:max-w-[540px] pb-5">
                                <div className=" flex-wrap w-full">
                                    <div className="gi-shop-rightsid">
                                        <div className="gi-pro-list-top md:flex items-center justify-between text-[13px] mb-[15px]">
                                            <div className="w-full gi-grid-list">
                                                <h2 className="text-xl font-semibold text-gray-900">All Pandit List</h2>
                                            </div>
                                            {/* <div className='flex gap-3 justify-end w-full'>
                                                <button
                                                    onClick={() => { setShowSort(true) }}
                                                    className="w-[130px] inline-flex items-center space-x-1 border px-3 py-1.5 rounded text-[13px] font-medium text-gray-900 hover:bg-gray-100 transition"
                                                >
                                                    <Filter className="w-4 h-4" />
                                                    <span>Sort by</span>
                                                </button>

                                                <input
                                                    value={globalFilter ?? ""}
                                                    onChange={(event) => setGlobalFilter(event.target.value)}
                                                    placeholder="Search By name"
                                                    className="w-full md:w-1/3 rounded border border-gray-300 bg-white  px-4 py-2 text-[13px] text-gray-900 shadow-theme-xs"
                                                />
                                            </div> */}
                                        </div>

                                        {/* <!-- Shop content Start --> */}
                                        <div className="shop-pro-content">
                                            <div className="shop-pro-inner">
                                                <div className="grid md:grid-cols-4 gap-2">
                                                    {currentAstroList?.length > 0 ? currentAstroList?.map((astro_list_result) => {
                                                        return (
                                                            <div className="grid_call_chat">
                                                                <div className="gi-product-content bg-white" >
                                                                    <div className="gi-product-inner transition-all duration-[0.3s] ease-in-out overflow-hidden rounded-[5px] shadow-xl pt-3">
                                                                        <div className="gi-pro-image-outer transition-all duration-[0.3s] delay-[0s] ease z-[11] relative">

                                                                            <div className="gi-pro-image overflow-hidden">

                                                                                <Link to={`/pandit/${astro_list_result?.user_name?.replace(/\s+/g, "-")}`}
                                                                                    className="image productimg relative block overflow-hidden ">
                                                                                    {
                                                                                        astro_list_result?.profile_image != null ? (
                                                                                            <img className="main-image rounded-full m-auto  w-[120px] h-[120px] transition-all duration-[0.3s] ease delay-[0s]"
                                                                                                src={`${IMG_BASE_URL}${astro_list_result?.profile_image}`} alt={`${astro_list_result?.name}_img`} />

                                                                                        ) : (

                                                                                            <img className="main-image rounded-full m-auto  w-[120px] h-[120px] transition-all duration-[0.3s] ease delay-[0s]"
                                                                                                src={Common_Images_Transport?.user_logo} alt={`${astro_list_result?.name}_img`} />
                                                                                        )
                                                                                    }
                                                                                </Link>

                                                                            </div>
                                                                        </div>
                                                                        <div className="gi-pro-content h-full p-3 pb-5 relative z-[10]  text-center">
                                                                            <div
                                                                                className="gi-pro-rat-price pb-2 flex justify-center gap-2 items-center">

                                                                                <span className="gi-pro-rating opacity-[0.7] relative">
                                                                                    {[...Array(5)].map((_, i) => (
                                                                                        <i
                                                                                            key={i}
                                                                                            className={`gicon gi-star inline-block float-left text-[13px] mr-[3px] ${i < astro_list_result?.average_rating ? 'text-[#f27d0c]' : 'text-[#ccc]'
                                                                                                }`}
                                                                                        ></i>
                                                                                    ))}
                                                                                    {/* <i className="gicon gi-star fill text-[16px] text-[#f27d0c] mr-[3px] float-left mr-[3px]"></i>
                                                                                    <i className="gicon gi-star fill text-[16px] text-[#f27d0c] mr-[3px] float-left mr-[3px]"></i>
                                                                                    <i className="gicon gi-star fill text-[16px] text-[#f27d0c] mr-[3px] float-left mr-[3px]"></i>
                                                                                    <i className="gicon gi-star text-[16px] text-gray-800 medium mr-[3px] float-left mr-[3px]"></i>
                                                                                    <i className="gicon gi-star text-[16px] text-gray-800 medium mr-[3px] float-left mr-[3px]"></i> */}
                                                                                </span>
                                                                                <span className="text-[13px] text-medium">{astro_list_result?.average_rating}</span>
                                                                            </div>
                                                                            <Link to={`/pandit/${astro_list_result?.user_name?.replace(/\s+/g, "-")}`} >
                                                                                <h5 className="text-gray-800 text-[15px] font-semibold capitalize">{astro_list_result?.name}</h5>
                                                                            </Link>

                                                                            <div className="mt-1">
                                                                                <div className="skills-container">
                                                                                    {astro_list_result?.skills && (
                                                                                        <span
                                                                                            className="line-clamp-1 text-gray-900 text-[12px] font-semibold text-center"
                                                                                        >
                                                                                            Skills: <span className='text-gray-600 font-medium'>{astro_list_result?.skills?.replace(/,/g, ", ")}</span>
                                                                                        </span>
                                                                                    )}

                                                                                </div>
                                                                                <div className="language-container">
                                                                                    {/* {astro_list_result?.language && ( */}
                                                                                    <span
                                                                                        className="line-clamp-1 text-gray-900 text-[12px] font-semibold text-center"
                                                                                    >
                                                                                        Language: <span className='text-gray-600 font-medium'>{astro_list_result?.language?.replace(/,/g, ", ")}</span>
                                                                                    </span>

                                                                                </div>
                                                                                <span
                                                                                    className="text-gray-900 text-[12px] font-semibold text-center">Exp.<span className='text-gray-600 font-medium'>{astro_list_result?.experience} Yrs</span></span>
                                                                                {/* <h6
                                                                                    className="gi-pro-stitle text-center font-normal text-[#000] text-[13px] font-semibold leading-[1.2] mt-4 capitalize">
                                                                                    Rs.{astro_list_result?.minute_rate}/min</h6> */}


                                                                            </div>

                                                                            <div className="flex justify-center mt-2">
                                                                                <button type="button" className="bg-red-500 hover:bg-red-600 px-3 py-2 rounded-xl text-white font-semibold text-sm" onClick={() => {

                                                                                    navigate("/book-pooja-payment", {
                                                                                        state: {
                                                                                            title: title,
                                                                                            image: image,
                                                                                            astro_name: astro_list_result?.name,
                                                                                            price: package_price,
                                                                                            id: id,
                                                                                            category_id: category_id,
                                                                                            short_description: short_description,
                                                                                            description: description,
                                                                                            astro_user_id: astro_list_result?.id,
                                                                                            pooja_id,
                                                                                            package_detail,
                                                                                            package_name,
                                                                                            poojalocation: poojaLocation?.selectedCity,
                                                                                            full_address: poojaLocation?.full_address || poojaLocation?.zipcode || poojaLocation?.selectedCity,
                                                                                            language,
                                                                                            pooja_date: selected_date,
                                                                                            from_time: selected_time,
                                                                                            muhurat_info
                                                                                        },
                                                                                    });

                                                                                }} >Select</button>
                                                                            </div>


                                                                        </div>
                                                                        {/* <div className="flex justify-between items-center border-t border-gray-200">
                                                                            <Link to={`/astrologer-details/${astro_list_result?.id}`} className="text-center flex justify-center w-full p-3 px-6 hover:text-red-800 border-r border-gray-200 gap-2 text-[13px] items-center font-semibold">
                                                                                <img src={Common_Images_Transport?.call_icon} className="h-7"
                                                                                    alt="" />
                                                                                Call
                                                                            </Link>

                                                                            <Link to={`/astrologerdetails/${astro_list_result?.id}`}
                                                                                className="text-center flex justify-center w-full p-3 px-6 hover:text-red-800 gap-2 text-[13px] items-center font-semibold">
                                                                                <img src={Common_Images_Transport?.chat_icon} className="h-7"
                                                                                    alt="" />
                                                                                Chat
                                                                            </Link>
                                                                        </div> */}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )
                                                    }) : (
                                                        <div>
                                                            <h3 className="text-gray-800 text-lg">No Pandit found</h3>
                                                        </div>

                                                    )
                                                    }
                                                </div>
                                            </div>
                                            {/* <!-- Pagination Start --> */}
                                            <div className="gi-pro-pagination pt-[15px] pb-[15px] flex justify-between items-center border-t-[1px] border-solid border-[#eee] max-[575px]:flex-col">
                                                <span className="text-[13px] text-gray-800 medium max-[575px]:mb-[10px]">Showing {startIndex + 1}-{Math.min(startIndex + productsPerPage, currentAstroList?.length)} of {currentAstroList?.length} items</span>
                                                <ul className="gi-pro-pagination-inner flex gap-1">
                                                    {currentPage > 1 && (
                                                        <li>
                                                            <button
                                                                onClick={handlePrev}
                                                                className="next w-auto text-[#fff] bg-[#5caf90] bg-red-500 text-[14px] px-2 rounded"
                                                            >
                                                                Prev
                                                            </button>
                                                        </li>
                                                    )}
                                                    {getPaginationItems().map((page, index) => {
                                                        if (page === '...') {
                                                            return (
                                                                <li key={`ellipsis-${index}`} className="inline-block float-left">
                                                                    <span className="transition-all duration-[0.3s] ease-in-out text-[#777] text-[14px]">
                                                                        ...
                                                                    </span>
                                                                </li>
                                                            );
                                                        }
                                                        return (
                                                            <li key={page} className="inline-block float-left">
                                                                <button
                                                                    onClick={() => handlePageChange(page)}
                                                                    className={`transition-all duration-[0.3s] ease-in-out font-light 
                                                                        text-[#777] bg-[#eee] px-2
                                                                        text-[14px] rounded
                                                                        ${currentPage === page ? 'active bg-red-500 text-white' : 'bg-gray-300 text-black'}`}
                                                                >
                                                                    {page}
                                                                </button>
                                                            </li>
                                                        );
                                                    })}
                                                    {currentPage < totalPages && (
                                                        <li>
                                                            <button
                                                                onClick={handleNext}
                                                                className="next w-auto text-[#fff] px-2 bg-[#5caf90] text-[14px] rounded"
                                                            >
                                                                Next
                                                            </button>
                                                        </li>
                                                    )}
                                                </ul>
                                            </div>
                                            <div className="sub__title text-gray-900 mt-3">{pageSeo?.description && parse(pageSeo?.description)}</div>

                                        </div>
                                    </div>



                                </div>
                            </div>
                        </section>
                    </>
                )}

            <Footer />
        </>
    );
}

export default Pandit_Consultant